import React, { useMemo } from 'react';
import { Joyride } from 'react-joyride';
import { useMediaQuery, useTheme } from '@mui/material';
import useTutorial from 'contexts/Tutorial';
import {
  getJoyrideOptions,
  JOYRIDE_MOBILE_FLOATING_OPTIONS,
  shouldCompleteTutorialFromJoyrideEvent,
} from 'utils/joyrideOnEvent';

const BooksTour = () => {
  const { shouldShowTutorial, completeTutorial, activeTutorialId } = useTutorial();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const tutorialId = 'books';

  const steps = useMemo(
    () => [
      {
        target: '[data-tour="books-search"]',
        content: 'Search by title or author to quickly find a book.',
        disableBeacon: true,
      },
      {
        target: '[data-tour="books-filter"]',
        content: 'Filter by theme, status, meeting schedule, or who suggested the book.',
        disableBeacon: true,
      },
      {
        target: '[data-tour="add_book_button"]',
        content: 'Add new books to your club’s list from here.',
        disableBeacon: true,
      },
      {
        target: '[data-tour="add_book_mobile_button"]',
        content: 'Add new books to your club’s list from here.',
        disableBeacon: true,
      },
      {
        target: '[data-tour="books-row"]',
        content: 'Tap a book row to open details and manage progress.',
        placement: isMobile ? 'top' : 'bottom',
        disableBeacon: true,
      },
      {
        target: '[data-tour="books-like"]',
        content: 'Like a book to show interest and boost it for the club.',
        placement: isMobile ? 'top' : 'bottom',
        disableBeacon: true,
      },
    ],
    [isMobile],
  );

  const run = shouldShowTutorial(tutorialId) || activeTutorialId === tutorialId;

  const handleEvent = (data) => {
    if (shouldCompleteTutorialFromJoyrideEvent(data)) {
      completeTutorial(tutorialId);
    }
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      scrollToFirstStep
      options={getJoyrideOptions({ isMobile })}
      floatingOptions={isMobile ? JOYRIDE_MOBILE_FLOATING_OPTIONS : undefined}
      onEvent={handleEvent}
    />
  );
};

export default BooksTour;
